
import { Component, DestroyRef, inject, OnDestroy, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RouterModule } from '@angular/router';
import { LoaderComponent } from '@components/shared/loader/loader.component';
import { NgSelectConfig } from '@ng-select/ng-select';
import { LoadingService } from '@services/loading.service';
import { DisplayScaleService } from '@services/display-scale.service';
import { MvpService } from '@services/mvp.service';
import { parseSearch } from '@utils/Navigation/parseSearch.utils';
import { TypeConstants } from '@values/Booking/TypeConstants.value';
import { NgxTranslateDebugService } from 'ngx-translate-debug';
import { Subscription } from 'rxjs';

@Component({
    selector: 'cck-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [RouterModule, LoaderComponent]
})
export class AppComponent implements OnInit, OnDestroy {
  private _ngSelectConfig = inject(NgSelectConfig);
  private _loadingService = inject(LoadingService);
  private _displayScaleService = inject(DisplayScaleService);
  private _translateDebugService = inject(NgxTranslateDebugService);
  private _mvpService = inject(MvpService);

  private readonly destroyRef = inject(DestroyRef);

  private loaderSub: Subscription;
  public isLoading: boolean;

  ngOnInit() {
    this._displayScaleService.init();

    (window as any)[TypeConstants.FUNNEL_GLOB_VAR] = 'nd';
    if (parseSearch()['DisableTokenReplacement']) {
      this._translateDebugService.enableDebug();
    } else {
      this._translateDebugService.disableDebug();
    }

    this._ngSelectConfig.clearAllText = '';
    this._ngSelectConfig.notFoundText = '';
    this._ngSelectConfig.loadingText = '';
    this._ngSelectConfig.typeToSearchText = '';

    const form: HTMLFormElement = document.querySelector('#aspnetForm');
    if (form) form.onsubmit = (ev) => ev.preventDefault();
    if (window.parent) document.body.classList.add('bg-transparent');
    this._mvpService.initBetaProgramUi();

    this.loaderSub = this._loadingService.isLoading$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((isLoading) => {
      setTimeout(() => {
          this.isLoading = isLoading;
      });
    });
  }

  ngOnDestroy(): void {
   this.loaderSub?.unsubscribe();
  }
}
